import { consola } from 'consola'
import type { RouteLocationNormalized } from "vue-router"
import { useUserProfileStore } from '@entities/user'
import { defineNuxtRouteMiddleware, useRouter, useRoute } from "#app"
import apiAuthInstance from "~/entities/auth/api"

// Logger
const logger = consola.withTag('email-verification-middleware')

/**
 * Middleware для обработки подтверждения почты через токен из URL
 * 
 * ✅ Проверяет наличие токена в query-параметрах
 * ✅ Отправляет токен на бэкенд для верификации
 * ✅ Обновляет данные пользователя после успешной верификации
 * ✅ Редиректит на страницу профиля
 */
export default defineNuxtRouteMiddleware(async (_to: RouteLocationNormalized) => {
  const storeUserProfile = useUserProfileStore()
  const router = useRouter()
  const route = useRoute()

  // Извлекаем токен из query-параметров
  const token: string | null = route.query.token as string | null

  // Обработка токена верификации
  if (token && process.client) {
    logger.info('Обнаружен токен верификации email, начинаем процесс подтверждения')
    
    apiAuthInstance
      .verifyEmail({ token })
      .then(({ message }) => {
        logger.success('Email успешно подтвержден:', message)
        return storeUserProfile.fetchUser()
      })
      .then(() => {
        logger.debug('Данные пользователя обновлены, редирект на профиль')
        router.push("/profile/personal-information")
      })
      .catch((error) => {
        logger.error("Ошибка подтверждения почты:", error)
      })
  }
})
